import { getUnixTime } from "date-fns/esm";
import { NetworkStatus } from "@apollo/client";

import useGetLeadTimeForChangesAverage from "shared/DoraMetrics/useGetLeadTimeForChangesAverage";

import useDoraDateRange from "../useDateRange";

const useDoraLeadTimeChangesAverage = () => {
  const { startTime, endTime } = useDoraDateRange();

  const { averageSeconds, loading, error, networkStatus } = useGetLeadTimeForChangesAverage({
    startTimeUnix: getUnixTime(startTime),
    endTimeUnix: getUnixTime(endTime),
  });

  const isLoading =
    (loading && typeof averageSeconds === "undefined") || networkStatus === NetworkStatus.refetch;

  return {
    averageSeconds,
    isLoading,
    error,
  };
};

export default useDoraLeadTimeChangesAverage;
